// extracted by mini-css-extract-plugin
module.exports = {"character-style-1":"RadioButton_character-style-1__C3z4y","container":"RadioButton_container__2i3CU","checkmark":"RadioButton_checkmark__1H_iC"};